import React from 'react';
import PropTypes from 'prop-types';

import sandosLogo from '../../../../static/images/SANDOS_logo_lg.png';
import marconfortLogo from '../../../../static/images/MARCONFORT_logo_lg.png';
import palmaiaLogo from '../../../../static/images/PALMAIARESORTS_logo_lg.png';

const chainLogos = {
  SANDOS: sandosLogo,
  MARCONFORT: marconfortLogo,
  PALMAIARESORTS: palmaiaLogo,
};

const getImgLoading = (chain, context) => {
  if (chain && chainLogos[chain]) {
    return <img src={chainLogos[chain]} className="logo" alt="loading"/>;
  }
  return <span>{context.t('Loading')}...</span>;
};

const Loading = ({ children, className, chain }, context) => (
        <div className={`${className}`}>
          <div className="flex flex-col items-center pb-8">
            {getImgLoading(chain, context)}
            <div className="loader-sandos"/>
            {children && <div className="text-gray-600 font-semibold text-base">
              {children}
            </div>}
          </div>
        </div>
);

Loading.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default Loading;
